var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-error"},[_c('h4',[_vm._v("Whoops...")]),_c('p',[_vm._v(" "+_vm._s(_vm.error|| _vm.erroPadrao)+" ")]),_c('Botao',{attrs:{"label":"Início","callback":_vm.voltarInicio}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }